module.exports = __webpack_public_path__ + "05_glasses_black.7b606953.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/05_glasses_black.png
// module id = X49g
// module chunks = 0